import logo from './logo.svg';
import './App.css';
import { Home } from './pages/Home/home';
import { ProjectsHome } from './pages/Projects';

function App() {
  return (
    <div className="App">
      <ProjectsHome/>
    </div>
  );
}

export default App;
